module.exports = __webpack_public_path__ + "static/media/screen1.b97dfd70.png";